// Add to cart from cart product
(() => {
  if (window.ssProductCardAddInitialized) return;
  window.ssProductCardAddInitialized = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-card-add-to-cart]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;
    button.disabled = true;
    button.classList.add('is-loading');
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        }
      );
      if (!response.ok) {
        throw new Error('Unable to add product to cart');
      }
      await response.json();
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      setTimeout(() => {
        button.classList.remove('is-added');
        button.disabled = false;
      }, 1000);
    } catch (error) {
      button.classList.remove('is-loading');
      button.disabled = false;
    }
  });
})();

// Custom countdown in cart drawer
(() => {
  if (window.ssCartBenefitsTimerInitialized) return;
  window.ssCartBenefitsTimerInitialized = true;

  const DURATION = 10 * 60 * 1000;
  const startTime = Date.now();

  const updateTimer = () => {
    const timers = document.querySelectorAll('.ss-cart-benefits__timer');

    if (!timers.length) return;

    const elapsed = (Date.now() - startTime) % DURATION;
    const remaining = Math.ceil((DURATION - elapsed) / 1000);

    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;

    const formattedTime =
      String(minutes).padStart(2, '0') +
      ':' +
      String(seconds).padStart(2, '0');

    timers.forEach((timer) => {
      timer.textContent = formattedTime;
    });
  };

  updateTimer();

  window.ssCartBenefitsTimerInterval = setInterval(updateTimer, 1000);
})();
